import { Div, Ref } from "@tblabs/truffle";
import { TabbedDescriptionPrinter } from "../../Components/Description/Tabs/TabbedDescriptionPrinter";
import { Gallery } from "../../Components/Description/Gallery/Gallery";
import { Product } from "../../Models/Product/Product";
import { Basket } from "../../Services/Basket/Basket";
import { Box } from "./Components/Box";
import { ProductBreadcrumbs } from "./Components/ProductBreadcrumbs";
import { OptionSelectionBox } from "./Components/OptionSelectionBox";
import { ProductFeatures } from "./Components/ProductFeatures";
import { Heading } from "../../Components/Heading";
import { ProductActionsBox } from "./ProductActionsBox";
import { ProductStatusBox } from "./ProductStatusBox";


export class ProductPageTemplate extends Div
{
    constructor(product: Product, basket: Basket, productOptionIdFromUrl: string)
    {
        super("product");

        const productOption = new Ref<string>(productOptionIdFromUrl || product.Options.List.Items[0]?.Url?.value || "");

        this.Append(
            new Box("product__container", [
                new ProductBreadcrumbs(product),
                new Box("product__content", [
                    new Box("product__left-column", [
                        new Heading(product.Title, 1, "product__title"),
                        new ProductFeatures(product),
                        new Gallery(product.Images),
                        new Box("product__info", [
                            new TabbedDescriptionPrinter(product.Tabs, product.Description),
                        ]),
                    ]),
                    new Box("product__right-column", [
                        new Box("product__info-features", [
                            new ProductStatusBox(product),
                            product.Options.List.Count > 1 && new OptionSelectionBox(product, productOption),
                        ]),
                        new ProductActionsBox(product, basket, productOption),
                    ]),
                ]),
            ])
        );
    }
}
